import z from "zod";
import { SupplierIdScheme } from "./ids";
import { Country } from "./enums/Country";
import { CatalogOrigin } from "./enums/CatalogOrigin";

export const SupplierDBScheme = z.object({
  id: SupplierIdScheme,
  name: z.string(),
  orgNumber: z.string().optional(),
  contactPerson: z.string().optional(),
  contactPhone: z.string().optional(),
  contactEmail: z.string().optional(),
  street: z.string().optional(),
  city: z.string().optional(),
  postalcode: z.string().optional(),
  country: z.enum(Country).optional(),
  note: z.string().optional(),
  origin: z.enum(CatalogOrigin).optional(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const RestGetSupplier = SupplierDBScheme;

export const RestCreateSupplier = SupplierDBScheme.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export const RestUpdateSupplier = SupplierDBScheme.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
}).partial();

export type DBSupplier = z.infer<typeof SupplierDBScheme>;
export type RestSupplier = z.infer<typeof RestGetSupplier>;
export type RestCreateSupplier = z.infer<typeof RestCreateSupplier>;
export type RestUpdateSupplier = z.infer<typeof RestUpdateSupplier>;
